import React, { useState } from "react";

import { pageTitle } from "../PageTitle";

import BreadCrumb from "../BreadCrumb";

import HeaderOne from "../Header/HeaderOne";

import FooterOne from "../Footer/FooterOne";

import { Link, useLocation } from "react-router-dom";

import two from "../../assets/images/resource/man.png";

import service from "../../assets/images/resource/PS.jpg";
import { Helmet } from "react-helmet-async";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/PS.png";

const Python = () => {
  pageTitle("Python & SQL Course");

  const [formData, setFormData] = useState({
    name: "",

    email: "",

    subject: "",

    phone: "",

    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);

    setFormData({
      name: "",

      email: "",

      subject: "",

      phone: "",

      message: "",
    });
  };

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const servicesData = [
    { id: 1, title: "AI & RPA", slug: "/rpa-training" },
    { id: 2, title: "Python & SQL", slug: "/python" },
    { id: 3, title: "Data Science With Python", slug: "/cloud" },
    {
      id: 4,
      title: "Cloudera Data Engineering",
      slug: "/data-engineering-course",
    },
    { id: 5, title: "Cloudera Machine Learning", slug: "/machine-learning" },
    { id: 6, title: "Cloudera AI", slug: "/AI" },
    { id: 7, title: "Cloudera Data analyst", slug: "/data-analyst" },
  ];

  const renderServices = () => {
    return servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/Python" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  };

  return (
    <>
      <Helmet>
        <title>Python & SQL Course - Learn Python Fast and Efficiently</title>
        <meta
          name="description"
          content="Join our 'Python & SQL' course and learn the essentials of Python programming. Perfect for beginners and experienced developers."
        />
        <meta
          name="keywords"
          content="Python course, learn Python, Python for beginners, Python programming, Python & SQL"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Python & SQL Course - Learn Python Fast and Efficiently"
        />
        <meta
          property="og:description"
          content="Join our 'Python & SQL' course and learn the essentials of Python programming. Perfect for beginners and experienced developers."
        />
        <meta property="og:image" content={g1} />
        <meta property="og:url" content={window.location.href} />
        <meta
          name="twitter:title"
          content="Python & SQL Course - Learn Python Fast and Efficiently"
        />
        <meta
          name="twitter:description"
          content="Join our 'Python & SQL' course and learn the essentials of Python programming. Perfect for beginners and experienced developers."
        />
        <meta name="twitter:image" content={g1} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <HeaderOne />

      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${g1})` }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative">
            {/* <ul className="bread__crumb">
                    <li><Link to="/">Home</Link></li>
                    {pathnames.map((name, index) => (
                    <li key={index}>
                        <span> -</span>
                        <Link to={`/${pathnames.slice(0, index + 1).join('/')}`}>{name}</Link>
                    </li>
                    ))}
                </ul> */}
            {/* <h1 className="title">{pathnames.length > 0 ? pathnames[pathnames.length - 1] : 'Home'}</h1> */}
          </div>
        </div>
      </section>
      <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12">
            <div className="service__right">
                <figure>
                  <img src={service} alt="Service" />
                </figure>
                <h2>
                  <span>Just Enough Python </span>
                </h2>
                <p>
                  Whether you’re new to programming or a seasoned developer
                  looking to pick up a new language, Just Enough Python is the
                  perfect starting point. This guide provides a streamlined,
                  practical approach to Python, giving you the essential skills
                  without overwhelming you with unnecessary details. You’ll
                  learn how to write clean, effective Python code that solves
                  real-world problems, automates tedious tasks, and helps you
                  build projects from scratch.
                  <br></br>
                  <br></br>
                  With Python’s simplicity, readability, and versatility, it has
                  become one of the most popular languages in the world. This
                  guide is designed to help you navigate Python’s most important
                  concepts, including variables, functions, data structures, and
                  libraries, so you can confidently apply them in your own work.
                  Whether you’re aiming to enter the world of data science, web
                  development, or simply automate tasks, Just Enough Python will
                  equip you with the tools and knowledge to get started quickly
                  and efficiently, making it ideal for both beginners and
                  experienced programmers looking to enhance their skills.
                </p>

                <br></br>

                <h3>
                  <span>Course Details</span>
                </h3>

                <ul className="course-details-list">
                  <li>

                      {" "}
                      <b>1. General Note - </b>{" "}

                     Exercise Environment Overview, Course
                    Exercises.
                  </li>

                  <li>

                      {" "}
                      <b>
                        {" "}
                        2. Running Python Scripts and Statements in the REPL -{" "}
                      </b>{" "}

                   Using the Interpreter, Executing a
                    Program, Executing Statements in the REPL.
                  </li>

                  <li>

                      {" "}
                      <b>
                        {" "}
                        3. Creating Virtual Environments and Using pip for
                        Managing Dependencies -{" "}
                      </b>{" "}

                     Creating a Virtual Environment, Installing
                    a Library.
                  </li>

                  <li>

                      {" "}
                      <b>4. Working with Variables -</b>{" "}

                     Variables in Python.
                  </li>

                  <li>

                      {" "}
                      <b>5. Controlling Program Flow -</b>{" "}

                    Controlling Program Flow Using if,
                    Controlling Program Flow Using while, Controlling Program
                    Flow Using for.
                  </li>

                  <li>

                      {" "}
                      <b>6. Creating Functions and Modules -</b>{" "}

                    Creating Functions, Built-in Functions,
                    Modules and Libraries.
                  </li>

                  <li>

                      {" "}
                      <b> 7. Using Data Structures -</b>{" "}

                     Working with Lists, Working with Tuples,
                    Working with Dictionaries, Working with Sets, Using Flow
                    Statements with Collections.
                  </li>

                  <li>

                      {" "}
                      <b> 8. Working with Files -</b>{" "}

                     Working with Files.
                  </li>

                  <li>

                      {" "}
                      <b>9. Essential & Data Science Libraries - </b>{" "}

                    Using the Python Standard Library, Using
                    numpy for Working with Numerical Data, Using pandas, the
                    Data Analysis Library, Using matplotlib to Visualize Data.
                  </li>

                  <li>

                      {" "}
                      <b>
                        10. Using Lambda Functions and Method Chaining -{" "}
                      </b>{" "}


                     Using Lambda Functions, Method Chaining.
                  </li>
                </ul>
              </div>
              <div className="service__right">

                <h2>
                  <span> SQL </span>
                </h2>
                <p>
                  This SQL course is designed to build a strong foundation in
                  database management and data manipulation. It covers essential
                  concepts and practical techniques to help you work efficiently
                  with structured data. Starting with the fundamentals, you will
                  explore how databases work, the role of SQL, and how to create
                  and manage data structures effectively.
                  <br></br>
                  <br></br>
                  As the course progresses, you will learn how to organize and
                  retrieve data efficiently, apply filtering and sorting
                  techniques, and ensure data integrity. You will also gain
                  insights into handling relationships between different
                  datasets, summarizing information, and optimizing queries for
                  better performance. Advanced techniques for working with
                  structured data will be introduced, allowing you to manage
                  complex queries and analyze large datasets effectively.With
                  hands-on exercises and real-world applications, this course
                  ensures you develop the confidence to manage databases
                  efficiently and apply SQL effectively in data-driven
                  environments.
                </p>

                <br></br>

                <h3>
                  <span>Course Details</span>
                </h3>

                <ul className="course-details-list">
                  <li>
                    <b>1. Introduction to SQL and Databases</b> - Understanding
                    databases and their importance, differences between SQL and
                    MySQL, overview of relational database management systems
                    (RDBMS), installation and setup of MySQL on different
                    operating systems.
                  </li>
                  <li>
                    <b>2. Database and Table Management</b> - Creating and
                    managing databases, understanding different data types,
                    defining structures for storing information, modifying
                    database components, and ensuring data organization with
                    essential rules.
                  </li>
                  <li>
                    <b>3. CRUD Operations (Create, Read, Update, Delete)</b> -
                    Adding new records, retrieving stored information, updating
                    existing entries, removing unwanted data, and maintaining
                    accuracy and consistency in databases.
                  </li>
                  <li>
                    <b>4. Filtering and Sorting Data</b> - Refining search
                    results using conditions, arranging information in a
                    specific order, eliminating duplicates, limiting results for
                    better performance, and searching for patterns within stored
                    data.
                  </li>
                  <li>
                    <b>5. Aggregate Functions and Grouping Data</b> -
                    Summarizing values, calculating totals, finding minimum and
                    maximum values, categorizing records into meaningful groups,
                    and filtering grouped results to extract relevant insights.
                  </li>
                  <li>
                    <b>6. Data Relationships and Combining Information</b> -
                    Understanding how different sets of information are linked,
                    retrieving related data from multiple sources, organizing
                    results for better reporting, and ensuring consistency in
                    connected records.
                  </li>
                  <li>
                    <b>7. Advanced Data Processing</b> - Applying conditional
                    logic to refine outputs, breaking complex tasks into smaller
                    steps, handling dates and time-based operations, and using
                    logical expressions to refine queries.
                  </li>
                  <li>
                    <b>8. Ensuring Data Integrity</b> - Maintaining uniqueness
                    in records, applying validation rules to prevent incorrect
                    entries, handling missing values effectively, and modifying
                    database structures when necessary.
                  </li>
                  <li>
                    <b>9. Window Functions in Data Analysis</b> - Analyzing data
                    across different sections without altering its structure,
                    categorizing and ranking information dynamically,
                    distributing records into groups, retrieving key values, and
                    accessing previous or upcoming data points.
                  </li>
                  <li>
                    <b>10. Real-World SQL Applications and Challenges</b> -
                    Applying database concepts to solve practical problems,
                    working with structured information efficiently, practicing
                    data management techniques, and handling large-scale
                    datasets effectively.
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 col-md-12">
              <div className="service__details__left">
                <div className="sidebar__widget">
                  <div className="all__service">
                    <h4>All Courses</h4>
                  </div>

                  <ul className="service__details__1__cat">
                    {renderServices()}
                  </ul>
                </div>

                <div
                  className="sidebar__widget_network"
                  style={{ backgroundImage: `url(${basebg})` }}
                >
                  <h3>Contact Us For Any Require</h3>

                  <div className="services__icon">
                    <i className="icon-19"></i>
                  </div>

                  <p>Need help? Call us:</p>

                  <h4>+65 90059743</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default Python;
